var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tabs" }, [
    _c(
      "menu",
      _vm._l(_vm.menu, function (m, i) {
        return _c(
          "span",
          {
            class: { active: _vm.currentIndex == i },
            on: {
              click: function ($event) {
                return _vm.onMenuClick(i)
              },
            },
          },
          [_vm._v(_vm._s(m))]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tab-content", class: "index" + _vm.currentIndex },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }